import { fillBotFlowsActionType, FlowActionTypes, saveFlowActionType } from "../../model/workflowEditor/flow/actions";
import { createActions } from "../../helpers/actionsHelper";
import { Flow } from "../../model/workflowEditor/flow/types";

export const fillBotFlowsAction = createActions<FlowActionTypes, {}, Flow[]>(fillBotFlowsActionType);

export const saveFlowAction = createActions<FlowActionTypes, Flow, Flow>(saveFlowActionType);